import { Entidade } from './../modules/basico/entidade/entidade';
import { UnidadeGestora } from './../modules/basico/unidade-gestora/unidade-gestora';
import { LayoutCss } from './../modules/basico/layout-css/layout-css';
import { Injectable, EventEmitter } from '@angular/core';
import { Usuario } from '../modules/seguranca/usuario/usuario';
import { CurrentUser } from '../modules/seguranca/current-user.model';
import { LayoutCssSerializer } from '../modules/basico/layout-css/layout-css.serializer';
// tslint:disable-next-line:max-line-length
import { IBGECaucaia, keyCompetenciaServidor, keySequencialServidor, keyReferenciaDecimo, keyCompetenciaRescisao, keyCompetenciaPagamentoRescisao } from './constants';
import { Permissao } from '../modules/seguranca/permissao/permissao';

@Injectable()
export class SharedService {
  public static instance: SharedService = null;
  private KEY_STORE_TOKEN = 'folpag-tk-auth-token';
  private KEY_STORE_USUARIO = 'folpag-tk-auth-user';
  private KEY_STORE_LAYOUT = 'folpag-tk-auth-layout';
  private KEY_STORE_UNIDADE = 'folpag-tk-auth-unidade';
  private KEY_STORE_ADM = 'folpag-tk-auth-adm';
  private KEY_STORE_PERMISSOES = 'folpag-tk-permissoes';
  usuario: Usuario;
  token: string;
  profile: string;
  layout: LayoutCss;
  permissoes : Permissao[] = [];
  private unidadeGestora: UnidadeGestora;
  modificouReferencia: EventEmitter<boolean> = new EventEmitter();
  modificouReferenciaDecimo: EventEmitter<boolean> = new EventEmitter();

  constructor() {
    return SharedService.instance = SharedService.instance || this;
  }

  public static getInstance() {
    if (this.instance === null) {
      this.instance = new SharedService();
      this.instance.token = JSON.parse(sessionStorage.getItem(this.instance.KEY_STORE_TOKEN));
      this.instance.usuario = JSON.parse(sessionStorage.getItem(this.instance.KEY_STORE_USUARIO));
      this.instance.layout = JSON.parse(sessionStorage.getItem(this.instance.KEY_STORE_LAYOUT));
      this.instance.unidadeGestora = JSON.parse(sessionStorage.getItem(this.instance.KEY_STORE_UNIDADE));
      this.instance.permissoes = JSON.parse(sessionStorage.getItem(this.instance.KEY_STORE_PERMISSOES));
      if (this.instance.layout) {
        this.instance.layout = new LayoutCssSerializer(LayoutCss).fromJson(this.instance.layout);
      }
    }
    return this.instance;
  }

  isLoggedIn(): boolean {
    if (!this.usuario) {
      return false;
    }
    return this.usuario.cpf !== '';
  }

  logando(userAuthentication: CurrentUser) {
    this.token = userAuthentication.token;
    sessionStorage.setItem(this.KEY_STORE_TOKEN, JSON.stringify(this.token));
    this.usuario = userAuthentication.usuario;
    this.layout = new LayoutCssSerializer(LayoutCss).fromJson(userAuthentication.layout);
    this.permissoes = userAuthentication.permissoes;
    if (this.usuario.unidadesGetoras.length === 1) {
      this.unidadeGestora = this.usuario.unidadesGetoras[0];
      sessionStorage.setItem(this.KEY_STORE_UNIDADE, JSON.stringify(this.unidadeGestora));
    }
    sessionStorage.setItem(this.KEY_STORE_USUARIO, JSON.stringify(this.usuario));
    sessionStorage.setItem(this.KEY_STORE_LAYOUT, JSON.stringify(this.layout));
    sessionStorage.setItem(this.KEY_STORE_PERMISSOES, JSON.stringify(this.permissoes));
  }

  logout() {
    this.token = null;
    this.usuario = null;
    this.unidadeGestora = null;
    this.layout = null;
    sessionStorage.removeItem(this.KEY_STORE_TOKEN);
    sessionStorage.removeItem(this.KEY_STORE_USUARIO);
    sessionStorage.removeItem(this.KEY_STORE_LAYOUT);
    sessionStorage.removeItem(this.KEY_STORE_UNIDADE);
    sessionStorage.removeItem(this.KEY_STORE_PERMISSOES);
    sessionStorage.clear();
  }

  set unidade(unidade: UnidadeGestora) {
    sessionStorage.removeItem(this.KEY_STORE_UNIDADE);
    this.unidadeGestora = unidade;
    sessionStorage.setItem(this.KEY_STORE_UNIDADE, JSON.stringify(this.unidadeGestora));
  }

  get unidade(): UnidadeGestora {
    return this.unidadeGestora;
  }

  mostrarCtps(): boolean {
    return this.usuario.entidade.municipio.idIBGE !== IBGECaucaia;
  }

  alterouReferencia(mesano, sequencial) {
    let competencia = sessionStorage.getItem(keyCompetenciaServidor);
    let sequencia = sessionStorage.getItem(keySequencialServidor);
    if (competencia !== mesano || sequencial !== sequencia) {
      sessionStorage.setItem(keyCompetenciaServidor, mesano);
      sessionStorage.setItem(keySequencialServidor, sequencial);
      this.modificouReferencia.emit(true);
    }
  }

  alterouReferenciaDecimo(mesano) {
    let referencia = sessionStorage.getItem(keyReferenciaDecimo);
    if (referencia !== mesano) {
      sessionStorage.setItem(keyReferenciaDecimo, mesano);
      this.modificouReferenciaDecimo.emit(true);
    }
  }

  alterouReferenciaRescisao(mesano, mesAnoPagamento) {
    let referencia = sessionStorage.getItem(keyCompetenciaRescisao);
    let referenciaPagamento = sessionStorage.getItem(keyCompetenciaPagamentoRescisao);
    if ((referencia !== mesano) && (referenciaPagamento !== mesAnoPagamento)) {
      sessionStorage.setItem(keyCompetenciaRescisao, mesano);
      sessionStorage.setItem(keyCompetenciaPagamentoRescisao, mesAnoPagamento);
      this.modificouReferenciaDecimo.emit(true);
    }
  }

  set entidade(entidade: Entidade) {
    this.usuario.entidade = entidade;
    sessionStorage.removeItem(this.KEY_STORE_USUARIO);
    sessionStorage.setItem(this.KEY_STORE_USUARIO, JSON.stringify(this.usuario));
  }

  set adm(is: boolean) {
    sessionStorage.removeItem(this.KEY_STORE_ADM);
    sessionStorage.setItem(this.KEY_STORE_ADM, is ? 'SIM' : 'NAO');
  }

  get adm(): boolean {
    let ad = sessionStorage.getItem(this.KEY_STORE_ADM);
    return ad ? ad === 'SIM' : false;
  }

  hasPermissao(routePath: string): boolean{
    let permissao: Permissao = this.permissoes.find(p => p.resource == routePath);
    return permissao && permissao.inserir;
  }

  getPermissao(routePath: string): Permissao{
    return this.permissoes.find(p => p.resource == routePath);
  }

}
